import { useEffect, useState } from "react";

import './File.css';
import { Svg_Upload } from "../../Svg";

interface Props {
    title: string;
    subtitle: string;
    file?: string;
    setValue: (file: File | string | null) => void;
}

export default function Comp_File(props: Props) {

    const [ preview, setPreview ] = useState<string>(props.file ?? '');

    function AddFile(file: File | null) {
        if (file) {
            setPreview(URL.createObjectURL(file));
            props.setValue(file);
        } else {
            setPreview(props.file ?? '');
            props.setValue(null);
        }
    }

    useEffect(() => {
        if (props.file) {
            setPreview(props.file);
            props.setValue(props.file);
        }
    }, [props.file]);

    return (
        <div className="Comp_File">
            <label className="file_label">
                {
                    preview ? 
                        <div className="show_img" style={ { backgroundImage: `url(${ preview })` } } />
                    : <Svg_Upload color="#999" className="icon_upload" />
                }

                <input type="file" onChange={ (e) => AddFile(e.target.files ? e.target.files[0] : null) } />
            </label>
            <div className="name_type_file">
                <div className="file_title">
                    { props.title }
                </div>
                <div className="file_subtitle">
                    { props.subtitle }
                </div>
            </div>
        </div>
    );
}
